import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataRetentionPolicyDetails, PolicyDataType } from 'src/app/shared/Models/WidgetSettingsModels';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'app-data-retention-policy',
  templateUrl: './data-retention-policy.component.html',
  styleUrls: ['./data-retention-policy.component.scss']
})
export class DataRetentionPolicyComponent implements OnInit {
  @Input() data: any;
  policy:any;
  customPolicyText='';
  dataRetentionPolicy:any;
  fromClient:boolean;
  constructor(public ls: LayoutService,private ts: TranslateService) { }

  ngOnInit(): void {
    this.customPolicyText= this.ls.restaurantWidgetSettings$.value.CustomPolicyText ? this.ls.restaurantWidgetSettings$.value.CustomPolicyText : '';
    this.dataRetentionPolicy={};
    this.ls.dataRetentionPolicy$.subscribe(data =>{
      if(data){
        this.policy=data;
        this.loadPolicies(this.policy.PolicyDetails);
      }
    });
  }

  
  loadPolicies(policyDetails) {
    policyDetails.forEach((policy: DataRetentionPolicyDetails ) => {
      if (policy.DataType == PolicyDataType.Name)
        this.dataRetentionPolicy.nameRetentionPeriod = policy.RetentionInDays;
      else if (policy.DataType == PolicyDataType.EmailAddress)
        this.dataRetentionPolicy.emailRetentionPeriod = policy.RetentionInDays;
      else if (policy.DataType == PolicyDataType.PhoneNumber)
        this.dataRetentionPolicy.phoneRetentionPeriod = policy.RetentionInDays;
      else if (policy.DataType == PolicyDataType.Address && this.ls.fromclient)
        this.dataRetentionPolicy.addressRetentionPeriod = policy.RetentionInDays;
      else if (policy.DataType == PolicyDataType.GuestImage && this.ls.fromclient)
        this.dataRetentionPolicy.guestImageRetentionPeriod = policy.RetentionInDays;
      else if (policy.DataType == PolicyDataType.BirthdayAndAnniversary && this.ls.fromclient)
        this.dataRetentionPolicy.birthdayAndAnniversaryRetentionPeriod = policy.RetentionInDays;
      else if (policy.DataType == PolicyDataType.CustomGuestFields)
        this.dataRetentionPolicy.customFieldRetentionPeriod = policy.RetentionInDays;
    })
  }

}
